<template>
    <div class="modal fade" :id="id">
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <button @click="closeModal('#' + id)" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row pricing-card">
                        <div class="col-12">
                            <div class="row match-height">
                                <template v-for="plan in planStore.salePlans" >
                                    <div class="col-12 col-md-4">
                                        <div class="card basic-pricing text-center" :class="{ popular: userStore.user.plan == plan.slug }">
                                            <div class="card-body d-flex flex-column">
                                                <div v-if="userStore.user.plan == plan.slug" class="pricing-badge text-left">
                                                    <div class="badge badge-pill badge-light-primary">Current Plan</div>
                                                </div>
                                                <img :src="plan.plan_image" class="mb-2 mt-5" alt="img-placeholder" />
                                                <h3>{{ plan.title }}</h3>
                                                <p class="card-text">{{ plan.plan_type}}</p>
                                                <div class="annual-plan">
                                                    <div class="plan-price mt-2">
                                                        <sup class="font-medium-1 font-weight-bold text-primary">$</sup>
                                                        <span class="pricing-basic-value font-weight-bolder text-primary">{{ plan.plan_price }} </span>
                                                        <sub class="pricing-duration text-body font-medium-1 font-weight-bold">/ {{ plan.plan_occurrance }}</sub>
                                                    </div>
                                                    <small class="annual-pricing d-none text-muted"></small>
                                                    <span v-html="plan.plan_description"></span>
                                                </div>
                                                <button @click="openPurchaseModal(plan.slug)" class="btn btn-block btn-outline-success mt-auto">Get Started</button>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <payment-modal
        :id="'payment-modal'"
        :selected-plan="selectedPlan"
        :coupon="coupon"
        :intent="intent"
    >
        <template #header>
            <div class="d-flex">
                <img src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/best-diy-credit-repair-software-official-logo.png" class="mb-2 w-50 mx-auto" alt="creditfixrr">
            </div>
            <h3 class="text-primary text-center">Payment Information</h3>
            <div v-if="error" class="alert alert-danger mt-1 alert-validation-msg" role="alert">
                <div class="alert-body">
                    <i data-feather="info" class="mr-50 align-middle"></i>
                    <span v-html="message"></span>
                </div>
            </div>
        </template>
        <template #form-attributes>
            <div class="col-6 col-md-6">
                <div class="form-group align-content-md-center mb-0">
                    <label for="coupon">Coupon</label>
                    <input type="text" v-model="coupon" name="coupon" class="form-control"/>
                </div>
            </div>
        </template>
        <template #footer="{ pay }">
            <button @click.once="pay" class="btn btn-primary" :key="planStore.paymentBtnKey">
                Subscribe
            </button>
            <div class="row">
                <div class="col-12">
                    <p class="mt-1">Payments are processed securely with Industry-Standard SSL Encryption.</p>
                </div>
            </div>
        </template>
    </payment-modal>
</template>
<script>
    import { defineComponent, ref, reactive, onBeforeMount } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { usePlanStore } from '../../stores/PlanStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import { closeModal, openModal, hideModal } from '../../utilities/_helpers'
    import PaymentModal from './PaymentComponent'

    export default defineComponent({
        name: 'SalePlansModal',
        props: {
            id: String,
        },
        components: {
            PaymentModal
        },
        setup(props) {
            return {
                closeModal: closeModal,
                coupon: ref(null),
                intent:ref(null),
                localizationStore: useLocalizationStore(),
                planStore: usePlanStore(),
                selectedPlan: ref(null),
                userStore: useUserStore(),
            }
        },
        computed: {
        },
        mounted() {
            if(!_.isEmpty(this.planStore.planData)){
                this.intent = this.planStore.planData.intent.client_secret
            }else{
                this.planStore.fetchPlans();
            }
        },
        watch: {
            'planStore.planData'(value){
                this.intent = value.intent.client_secret
            }
        },
        created() {
        },
        methods: {
            openPurchaseModal(slug) {
                this.selectedPlan = slug;
                openModal('#payment-modal');
            },
        }
    });
</script>
